import { useState, useRef } from "react";
import useOnClickOutside from "use-onclickoutside";
import {
  TD,
  CellWrapper,
  CellValue,
  CellOptionsWrapper,
  CellButton,
  CellIcon,
  CellDropDown,
  CellDropDownItems,
  CellDropDownItem,
} from "../styledEdit";

const CellNumber = ({ rowIdx, setSettingsDraft, addRow, removeRow }) => {
  const [hovered, setHovered] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);

  const ref = useRef();

  useOnClickOutside(ref, () => setDropDownOpen(false));

  return (
    <TD>
      <CellWrapper
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <CellValue cellNumber>{rowIdx + 1}</CellValue>
        <CellOptionsWrapper ref={ref}>
          {(hovered || dropDownOpen) && (
            <CellButton onClick={() => setDropDownOpen(!dropDownOpen)}>
              <CellIcon className="fas fa-chevron-down" />
            </CellButton>
          )}
          {dropDownOpen && (
            <CellDropDown right>
              <CellDropDownItems>
                {/* <CellDropDownItem onClick={() => { setSettingsDraft({ type: 'row' }); setHovered(false); setDropDownOpen(false) }} right>
                    <em className="far fa-cog" style={{ marginRight: '8px' }} />
                    <span>Settings</span>
                  </CellDropDownItem> */}
                <CellDropDownItem
                  onClick={() => {
                    addRow(rowIdx);
                    setHovered(false);
                    setDropDownOpen(false);
                  }}
                  right
                >
                  <em
                    className="far fa-arrow-alt-to-top"
                    style={{ marginRight: "8px" }}
                  />
                  <span>Prepend row</span>
                </CellDropDownItem>
                <CellDropDownItem
                  onClick={() => {
                    addRow(rowIdx + 1);
                    setHovered(false);
                    setDropDownOpen(false);
                  }}
                  right
                >
                  <em
                    className="far fa-arrow-alt-to-bottom"
                    style={{ marginRight: "8px" }}
                  />
                  Append row
                </CellDropDownItem>
                <CellDropDownItem
                  onClick={() => {
                    removeRow(rowIdx);
                    setHovered(false);
                    setDropDownOpen(false);
                  }}
                  right
                >
                  <em
                    className="far fa-trash-alt"
                    style={{ marginRight: "8px" }}
                  />
                  <span>Remove row</span>
                </CellDropDownItem>
              </CellDropDownItems>
            </CellDropDown>
          )}
        </CellOptionsWrapper>
      </CellWrapper>
    </TD>
  );
};

export default CellNumber;
